import { withRouter } from "react-router";



const pathMap={
    '/':'Home',
    '/eligibility':'Eligibility',
    '/coverage-periods-rates':'Coverage Rates',
    '/plan-details':'Plan Details',
    '/care':'Access Care',
    '/Contacts':'Contacts'





}

export default (obj,pathName) =>{


    

    (document.title = `${obj.brandID} | ${obj.id} | ${pathMap[pathName]}`);

}
